import { lazy } from 'react'

import EmptyFallback from '~/components/render-kit/EmptyFallback'
import RenderWhenVisible from '~/components/render-kit/RenderWhenVisible'
import ReCaptchaProvider from '~/components/shared/ReCaptchaProvider'

const ContactForm = lazy(() => import('~/components/forms/ContactForm'))

type Props = {
  isModal?: boolean
}

const LazyContactForm = ({ isModal }: Props) => (
  <RenderWhenVisible withSuspense fallback={<EmptyFallback minHeight={564} />}>
    <ReCaptchaProvider>
      <ContactForm title="Tell us about your project:" isModal={isModal} />
    </ReCaptchaProvider>
  </RenderWhenVisible>
)

export default LazyContactForm
